import { Button } from "@msuite/ui/button";
import { useDisclosure } from "@msuite/ui/hooks";
import { Icon } from "@msuite/ui/icons";
import { useTranslation } from "@msuite/ui/localization";
import { useDataTableContext } from "@msuite/ui/table";
import React from "react";
import { AddProjectContactModal } from "@/modals/projects/add-project-contact-modal";

/** Props Interface */
interface SubstitutionPlanContactFormMenuProps {
	projectId: string;
}

export function SubstitutionPlanContactFormMenu({
	projectId,
}: SubstitutionPlanContactFormMenuProps) {
	/** Context */
	const { refetch } = useDataTableContext();

	/** Hooks */
	const disclosure = useDisclosure();
	const { t } = useTranslation();

	/** Render */
	return (
		<React.Fragment>
			<Button
				variant="primary"
				icon={<Icon name="Plus" />}
				onClick={disclosure.onOpen}
			>
				{t("contacts.add_contact")}
			</Button>
			{disclosure.isOpen && (
				<AddProjectContactModal
					projectId={projectId}
					isOpen={disclosure.isOpen}
					onClose={disclosure.onClose}
					onComplete={async () => {
						refetch?.();
					}}
				/>
			)}
		</React.Fragment>
	);
}
